import React from "react";
import type { CanvasBuilderElement } from "../../views/canvasBuilderProjection";
import type { CanvasGridConfig } from "../../types";
import { CanvasGridElement } from "./CanvasGridElement";

interface NestedCanvasGridElementProps {
  element: CanvasBuilderElement;
  config: CanvasGridConfig;
  mode: "edit" | "preview";
  isSelected: boolean;
  isHovered: boolean;
  isDragging?: boolean;
  isDropTarget?: boolean;
  onSelect: (additive?: boolean) => void;
  onHover: (isHovered: boolean) => void;
  onDelete: () => void;
  onDuplicate: () => void;
  onResize: (columnSpan: number, rowSpan: number) => void;
  children?: React.ReactNode;
}

/**
 * Render one nested builder element with the same accessible drag and selection
 * behavior as a root element. Its grid placement remains relative to its
 * container's internal grid.
 */
export default function NestedCanvasGridElement({
  element,
  ...props
}: NestedCanvasGridElementProps) {
  const label = String(element.props.label || element.type);

  return (
    <CanvasGridElement
      id={element.tempId}
      gridColumn={element.gridColumn}
      gridRow={element.gridRow}
      columnSpan={element.columnSpan}
      rowSpan={element.rowSpan}
      label={label}
      elementType={element.type}
      isBound={!!element.data_binding}
      {...props}
    />
  );
}
